module.exports = __webpack_public_path__ + "static/bk-3-d1211e69b61f350fd2b70d7b9dc66df4.png";